// export const apiUrl = "http://localhost:59633"
export const apiUrl = process.env.REACT_APP_API_URL;

// Боевой стенд определяем по адресу API. Используется, чтобы тестовые переключатели
// (например эмуляция заявки из мобильного приложения) были видны везде, кроме прода.
// У всех брокеров боевой API живёт на app.<домен> (app.doscar.kz, app.jetq.kz), тестовый —
// на test-app.<домен>. Раньше проверялся только app.doscar.kz, и на боевом JetQ менеджеры
// видели тестовый переключатель «считать заявку поданной из мобильного приложения».
export const isProdApiUrl = (url) => /^https?:\/\/app\./i.test(String(url || '').trim());
export const IS_PROD_STAND = isProdApiUrl(process.env.REACT_APP_API_URL);
export const apiAdminUrl = process.env.REACT_APP_API_ADMIN_URL;
export const localApiUrl = process.env.REACT_APP_LOCAL_API_URL;
// export const apiUrl = 'https://test-app.doscar.kz';
// export const apiAdminUrl = 'https://test-admin.doscar.kz';
export const PAYMENT_TYPES_PREPAYMENT_INVOICE = 4;
export const PAYMENT_TYPES_PREPAYMENT_CARD = 5;
export const PAYMENT_TYPES_CREDIT_CARD = 7;
export const PAYMENT_TYPES_CREDIT_INVOICE = 6;
export const PAYMENT_TYPES_OPTIONS = [
  { value: PAYMENT_TYPES_PREPAYMENT_INVOICE, label: 'Предоплата (счет на оплату)' },
  { value: PAYMENT_TYPES_PREPAYMENT_CARD, label: 'Предоплата (оплата картой)' },
  { value: PAYMENT_TYPES_CREDIT_INVOICE, label: 'Автокредит' },
  // { value: PAYMENT_TYPES_CREDIT_CARD, label: 'Автокредит (оплата картой)' },
];

export const CREDIT_TYPE_ID = 3;
export const INSURANCE_ID = 6;

export const INSURANCE_SERVICE_ID_2_5 = 8;
export const INSURANCE_SERVICE_ID_3 = 6;
export const INSURANCE_SERVICE_ID_3_5 = 7;

export const DOCUMENT_TYPES_INVOICE = 1;
export const DOCUMENT_TYPES_CONTRACT = 2;
export const DOCUMENT_TYPES_POLES = 3;
export const DOCUMENT_TYPES_PAYMENT_CONFIRMATION = 4;
export const DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT = 5;
export const DOCUMENT_TYPES_POWER_OF_ATTORNEY = 7;
export const DOCUMENT_TYPES_SPOUSE_CONSENT = 8;
export const DOCUMENT_TYPES_TECH_PASSPORT = 9;
export const DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT = 19;
export const DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES = 20;

export const DOCUMENT_TYPES_GRNZ = 12;
export const DOCUMENT_TYPES_PLEDGE_AGREEMENT = 13;
export const DOCUMENT_TYPES_PLEDGE_APPLICATION = 14;
export const DOCUMENT_TYPES_UDV = 15;
export const DOCUMENT_TYPES_UDV_SPOUSE = 16;
export const DOCUMENT_TYPES_NO_TAX_DEBT = 17;
export const DOCUMENT_TYPES_APPLICATION_PREMIUM_AND_ADDITIONAL_EQUIPMENT_LOAN = 18;
export const DOCUMENT_TYPES_GUARANTEE_LETTER = 23;
export const DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES = 24;
export const DOCUMENT_TYPES_PAYMENT_ORDER = 25;
export const DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE = 32;
export const DOCUMENT_TYPES_MARRIAGE_CONTRACT = 31;
export const DOCUMENT_TYPES_VEHICLE_RETURN_CONFIRMATION_LETTER = 34;
export const DOCUMENT_TYPES_LOAN_APPROVAL_NOTIFICATION = 37;
// График платежей банка. Jet Finance гарантийного письма не выдаёт, и это
// единственный документ, который мы от него получаем.
export const DOCUMENT_TYPES_PAYMENT_SCHEDULE = 50;
export const DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION = 41; // Документ подтверждающий прохождение таможенного оформления
export const DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION = 42; // Документ подтверждающий исполнение расширенных обязательств производителями (импортерами)
export const DOCUMENT_TYPES_ORIGIN_CERTIFICATE = 43; // Сертификат о происхождении товара
export const DOCUMENT_TYPES_CUSTOMER_LICENSE_CAR_ASSESSMENT = 44; // УДЛ клиента (оценка авто)
export const DOCUMENT_TYPES_TECH_PASSPORT_CAR_ASSESSMENT = 45; // Техпаспорт (оценка авто)
export const DOCUMENT_TYPES_CAR_PHOTO_CAR_ASSESSMENT = 46; // Фото автомобиля (оценка авто)
export const DOCUMENT_TYPES_VIN_PHOTO_CAR_ASSESSMENT = 47; // Фото VIN-кода (оценка авто)
export const DOCUMENT_TYPES_ODOMETER_PHOTO_CAR_ASSESSMENT = 48; // Фото одометра (оценка авто)
export const DOCUMENT_TYPES_TRIPARTITE_CONTRACT = 49; // Трёхсторонний договор купли-продажи (поручение)

export const DOCUMENT_STATUS_SIGNED = 3;
export const DOCUMENT_STATUS_SIGNED_BY_DIRECTOR = 6;

export const DOCUMENT_TYPES_OPTIONS = [
  { value: DOCUMENT_TYPES_INVOICE, label: 'Счет на оплату' },
  { value: DOCUMENT_TYPES_CONTRACT, label: 'Договор купли продажи' },
  { value: DOCUMENT_TYPES_POLES, label: 'Полис' },
  { value: DOCUMENT_TYPES_PAYMENT_CONFIRMATION, label: 'Подтверждение оплаты' },
  { value: DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT, label: 'Соглашение на обработку персональных данных' },
  { value: DOCUMENT_TYPES_SPOUSE_CONSENT, label: 'Согласие супруги' },
  { value: DOCUMENT_TYPES_POWER_OF_ATTORNEY, label: 'Доверенность' },
  { value: DOCUMENT_TYPES_TECH_PASSPORT, label: 'Техпаспорт (скан)' },
  { value: DOCUMENT_TYPES_GUARANTEE_LETTER, label: 'Гарантийное письмо' },
  { value: DOCUMENT_TYPES_PAYMENT_ORDER, label: 'Платежное поручение банк' },
];

export const MARITAL_STATUS_UNDEFINED = 0;
export const MARITAL_STATUS_SINGLE = 1;
export const MARITAL_STATUS_MARRIED = 2;
export const MARITAL_STATUS_WIDOWED = 3;
export const MARITAL_STATUS_LIVING_TOGETHER = 4;
export const MARITAL_STATUS_DIVORCED = 5;

export const MARITAL_STATUS_OPTIONS = [
  {
    label: 'Не указано',
    value: MARITAL_STATUS_UNDEFINED,
  },
  {
    label: 'Холост/Не замужем',
    value: MARITAL_STATUS_SINGLE,
  },
  {
    label: 'Женат/Замужем',
    value: MARITAL_STATUS_MARRIED,
  },
  {
    label: 'Вдовец/Вдова',
    value: MARITAL_STATUS_WIDOWED,
  },
  {
    label: 'Гражданский брак',
    value: MARITAL_STATUS_LIVING_TOGETHER,
  },
  {
    label: 'Разведен',
    value: MARITAL_STATUS_DIVORCED,
  },
];

export const CLIENT_DOCUMENT_TYPE = [
  { value: 1, label: 'Удостоверение личности' },
  { value: 5, label: 'Дипломатический паспорт' },
  { value: 2, label: 'Паспорт' },
  { value: 4, label: 'Вид на жительство иностранца' },
  { value: 8, label: 'Лицо без гражданства РК' },
];

export const CLIENT_DOCUMENT_ISSUED_BY = [
  { value: 1, label: 'МВД РК', code: 'MINISTRY_OF_THE_INTERIOR' },
  { value: 2, label: 'МЮ РК', code: 'MINISTRY_OF_JUSTICE' },
];

export const CLIENT_NOTARIAL_VERIFICATION_PENDING = 1;
export const CLIENT_NOTARIAL_VERIFICATION_APPROVED = 2;
export const CLIENT_NOTARIAL_VERIFICATION_REJECTED = 3;

export const CLIENT_NOTARIAL_VERIFICATION_OPTIONS = [
  { value: CLIENT_NOTARIAL_VERIFICATION_PENDING, label: 'Ожидает проверки' },
  { value: CLIENT_NOTARIAL_VERIFICATION_APPROVED, label: 'Прошел проверку' },
  { value: CLIENT_NOTARIAL_VERIFICATION_REJECTED, label: 'Не прошел проверку' },
];

export const PAYMENT_STATUS_PAID = 1;
export const PAYMENT_STATUS_NOT_PAID = 2;

export const DEAL_STATUS_DOCUMENTS_PROCESSING = 1;
export const DEAL_STATUS_FULL_PAYMENT = 2;
export const DEAL_STATUS_REMARKS = 3;
export const DEAL_STATUS_ACT_UPLOADED = 4;
export const DEAL_STATUS_FAILED = 5;
export const DEAL_STATUS_COMPLETED = 6;
export const DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED = 7;
export const DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS = 8;
export const DEAL_STATUS_NEED_TO_MAKE_POWER_OF_ATTORNEY = 9;
export const DEAL_STATUS_WAITING_FOR_PAYMENT = 10;
export const DEAL_STATUS_CAR_ISSUED = 11;
export const DEAL_STATUS_WAIRING_REGISTRATION = 12;
export const DEAL_STATUS_WAITING_FOR_SIGNING_CONTRACT = 13;
export const DEAL_STATUS_CONTRACT_SIGNED = 15;
export const DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT = 14;
export const DEAL_STATUS_WAITING_FOR_PLEDGE_DOCUMENTS = 17;
export const DEAL_STATUS_WAITING_SIGNING_APPLICATION_FOR_ADDITIONAL_SERVICES = 16;
export const DEAL_STATUS_WAITING_CLIENT_BANK_DOSCAR_AGREEMENT = 18;
export const DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS = 17;
export const DEAL_STATUS_READY_FOR_CONCLUSION_OF_CREDIT_AGREEMENT = 19;
// Этап банков и анкета: раньше на них стоял «Ожидает оплаты».
export const DEAL_STATUS_WAITING_CONSENT_SIGNING = 25;
export const DEAL_STATUS_WAITING_BANK_DECISION = 26;
export const DEAL_STATUS_BANK_APPROVED = 27;
export const DEAL_STATUS_FILLING_QUESTIONNAIRE = 28;

export const DEAL_STATUS_WAITING_FOR_FREEDOM = 20;
export const DEAL_STATUS_WAITING_FOR_HALYK = 21;

export const DEAL_STATUS_CAR_DELIVERY = 22;
export const DEAL_STATUS_REJECTED = 23;

export const DEAL_STATUSES = [
  { value: DEAL_STATUS_DOCUMENTS_PROCESSING, label: 'Оформление док-в' },
  { value: DEAL_STATUS_FULL_PAYMENT, label: 'Полная оплата' },
  { value: DEAL_STATUS_REMARKS, label: 'Замечания к сделке' },
  { value: DEAL_STATUS_ACT_UPLOADED, label: 'Акт П/П подгружен' },
  { value: DEAL_STATUS_FAILED, label: 'Сделка провалена' },
  { value: DEAL_STATUS_COMPLETED, label: 'Завершена' },
  { value: DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED, label: 'Нотариальные документы оформлены' },
  { value: DEAL_STATUS_WAITING_FOR_NOTARIAL_DOCUMENTS, label: 'Ожидает нотариальных документов' },
  {
    value: DEAL_STATUS_NEED_TO_MAKE_POWER_OF_ATTORNEY,
    label: 'Необходимо оформить доверенность на постановку на учет',
  },
  { value: DEAL_STATUS_WAITING_FOR_PAYMENT, label: 'Ожидает оплаты' },
  { value: DEAL_STATUS_WAIRING_REGISTRATION, label: 'Ожидает постановки на учет' },
  { value: DEAL_STATUS_CAR_ISSUED, label: 'Машина выдана' },
  { value: DEAL_STATUS_WAITING_FOR_SIGNING_CONTRACT, label: 'Ожидает подписания договора' },
  { value: DEAL_STATUS_CONTRACT_SIGNED, label: 'Договор подписан' },
  { value: DEAL_STATUS_WAITING_FOR_REGISTRATION_BY_CLIENT, label: 'Ожидает постановки на учет клиентом' },
  { value: DEAL_STATUS_REJECTED, label: 'Неудачная сделка' },
];

export const CAR_DOCUMENT_TYPES = [
  { value: 1, label: 'Свидетельство о регистрации ТС' },
  { value: 2, label: 'ПТС' },
  { value: 3, label: 'Сертификат об оплате утилизационного сбора' },
  { value: 4, label: 'Сертификат соответствия' },
  { value: 5, label: 'Сертификат о прохождении таможенной очистки' },
  { value: 6, label: 'Договор выкупа' },
  { value: 7, label: 'Акт приёмки/осмотра автомобиля' },
  { value: 8, label: 'Фотографии автомобиля' },
];

export const CLIENT_CONTACT_PERSON_TYPES = [
  { value: 'Жена', label: 'Жена' },
  { value: 'Муж', label: 'Муж' },
  { value: 'Мама', label: 'Мама' },
  { value: 'Отец', label: 'Отец' },
  { value: 'Дочь', label: 'Дочь' },
  { value: 'Сын', label: 'Сын' },
  { value: 'Брат', label: 'Брат' },
  { value: 'Сестра', label: 'Сестра' },
  { value: 'Коллеги', label: 'Коллеги' },
  { value: 'Друзья', label: 'Друзья' },
];

export const RESIDENT_TYPES = [
  { value: 1, label: 'Резидент' },
  { value: 0, label: 'Не резидент' },
];

export const BANKS = {
  EURAZ: 1,
  BCK: 2,
  FREEDOM: 3,
  BEREKE: 4,
  // HALYK: 5,
  HALYK: 5,
  FORTE: 6,
  SHINHAN: 7,
  ALTYN: 8,
  TFS: 9,
  SAPA: 10,
  MYCAR: 11,
  JETFIN: 14,
  TEST: 100,
};

// Банки, принимающие заявки по БУ-авто (выкуп, мена, договор поручения).
// Береке, Алтын и Форте БУ не различают или не принимают — им не шлём.
export const USED_CAR_BANK_IDS = [
  BANKS.EURAZ,
  BANKS.BCK,
  BANKS.FREEDOM,
  BANKS.HALYK,
  BANKS.SHINHAN,
  BANKS.SAPA,
  // MyCar Finance работу с пробегом подтвердил (переписка с банком 02.10.2026):
  // в заявку уходит признак «не новый», VIN и пробег. Банк виден в выборе только
  // в сборке с REACT_APP_MYCAR_ENABLED=true, поэтому на проде список не меняется.
  BANKS.MYCAR,
  // Jet Finance принимает и БУ, и новые: у новой машины ставим признак is_new,
  // и госномер с техпаспортом банк не требует. Виден только в сборке с
  // REACT_APP_JETFIN_ENABLED=true — на проде списка не меняет.
  BANKS.JETFIN,
];

export const BANKS_OPTIONS = [
  { value: BANKS.EURAZ, label: 'Eurasian Bank' },
  { value: BANKS.BCK, label: 'Bank CenterCredit', image: 'http://app.doscar.kz/images/banks/logo/bcc.png' },
  { value: BANKS.FREEDOM, label: 'Freedom Bank', image: 'https://app.doscar.kz/images/banks/logo/Freedom.png' },
  { value: BANKS.BEREKE, label: 'Bereke Bank', image: 'http://app.doscar.kz/images/banks/logo/Bereke.png' },
  { value: BANKS.HALYK, label: 'Halyk Bank', image: 'http://app.doscar.kz/images/banks/logo/halyk.png' },
  { value: BANKS.FORTE, label: 'ForteBank', image: 'http://app.doscar.kz/images/banks/logo/forte.png' },
  { value: BANKS.SHINHAN, label: 'Shinhan Bank', image: 'http://app.doscar.kz/images/banks/logo/shinhan.png' },
  { value: BANKS.ALTYN, label: 'Altyn Bank', image: 'https://app.doscar.kz/images/banks/logo/altyn.png' },
  { value: BANKS.SAPA, label: 'Sapa Digital Finance' },
  // ТФС отключён: с сентября 2026 банк не принимает заявки — последняя принятая
  // была 22.09.2025, дальше 69 тысяч заявок ушли в никуда. Убран из выбора, чтобы
  // менеджер его не отмечал, а клиент не подписывал согласие в его пользу.
  // { value: BANKS.TFS, label: 'TFS', image: 'https://app.doscar.kz/images/banks/logo/tfs.jpg' },
  // MyCar Finance (МФО): запуск 09.2026. Пока проверяем на тесте, в выборе банков
  // он есть только в сборке с REACT_APP_MYCAR_ENABLED=true — на проде не виден.
  ...(process.env.REACT_APP_MYCAR_ENABLED === 'true' ? [{ value: BANKS.MYCAR, label: 'mycar finance' }] : []),
  // Jet Finance (система Rubie): запуск 10.2026, пока только тест. Это банк,
  // не наш брокер JetQ. На проде опции нет — сборка без REACT_APP_JETFIN_ENABLED.
  ...(process.env.REACT_APP_JETFIN_ENABLED === 'true'
    ? [{ value: BANKS.JETFIN, label: 'Jet Finance', image: 'https://app.doscar.kz/images/banks/logo/jetfin.png' }]
    : []),
  // { value: BANKS.TEST, label: 'TEST', image: "https://app.doscar.kz/images/banks/logo/test.png"},
];

export const DEAL_STEPS = {
  FINISH: 10,
  SELECT_BANKS: 5,
  NOTARIAL_DOCUMENTS: 6,
  CAR_DELIVERY: 9,
  CLIENT_PAYMENT_APPROVE: 100,
  CLIENT_REGISTRATION_APPROVE: 101,
  SIGN_CONTRACT: 102,
  // Авто по договору поручения: трёхсторонний договор формируется после выбора
  // банка и до ДКП. Для остального стока шаг пропускается.
  TRIPARTITE_CONTRACT: 103,
  HALYK: {
    SIGN_CONTRACT: 200,
    NOTARIAL_VERIFICATION: 20,
    WAITING_FOR_PAYMENT: 21,
    AUTO_REGISTRATION: 22,
    WAITING_FOR_FINAL_ACTIONS: 23,
    CAR_DELIVERY: 24,
    SHOW_GUARANTEE_LETTER: 25,
  },
  FREEDOM: {
    SIGN_CONTRACT: 300,
    WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE: 31,
    WAITING_FOR_CLIENT_DOCUMENTS: 32,
    WAITING_FOR_PAYMENT: 33,
    AUTO_REGISTRATION: 34,
    WAITING_FOR_FINAL_ACTIONS: 35,
  },
  FORTE: {
    NOTARIAL_VERIFICATION: 41,
    WAITING_FOR_CLIENT_DOCUMENTS: 42,
    WAITING_FOR_PAYMENT: 43,
    AUTO_REGISTRATION: 44,
    AUTO_REREGISTRATION: 49,
    WAITING_FOR_FINAL_ACTIONS: 45,
    CAR_DELIVERY: 46,
    WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_MOBILE_APP: 47,
    WAITING_FOR_CLIENT_ACTIONS_ON_FORTE_SIDE: 48,
    WAITING_NEW_STATUS: 411,
    SIGN_CONTRACT: 422,
  },
  BEREKE: {
    SIGN_CONTRACT: 500,
    WAITING_FOR_CLIENT_ACTIONS: 50,
    CAR_DELIVERY: 51,
  },
  BCK: {
    SIGN_CONTRACT: 600,
    NOTARIAL_VERIFICATION: 61,
    WAITING_FOR_PAYMENT: 62,
    WAITING_BANK_ACTIONS: 63,
    AUTO_REREGISTRATION: 64,
    CAR_DELIVERY: 65,
  },
  SHINHAN: {},
  ALTYN: {
    SIGN_CONTRACT: 80,
    WAITING_FOR_PAYMENT: 81,
    AUTO_REREGISTRATION: 84,
  },
  EURAZ: {
    SIGN_CONTRACT: 1001,
    AUTO_REGISTRATION: 1002,
    CAR_DELIVERY: 1003,
    DOCUMENTS_FOR_USED_CAR: 1008,
    WAITING_FOR_PAYMENT: 1004,
    NOTARIAL_VERIFICATION: 1005,
    EDIT_CAR_GOS_NUMBER: 1006,
    ADIITIONAL_DOCUMENTS: 1007,
  },
};
